var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMerchantProduct(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-merchant-product"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "merchant-product",
    clipPath: "url(#clip-merchant-product)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shopping-cart_1_",
    "data-name": "shopping-cart (1)",
    transform: "translate(0 -18.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3057",
    "data-name": "Group 3057",
    transform: "translate(11.266 44.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3056",
    "data-name": "Group 3056",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6479",
    "data-name": "Path 6479",
    d: "M172.646,402.828a2.99,2.99,0,1,0,2.99,2.99A2.994,2.994,0,0,0,172.646,402.828Zm0,4.311a1.321,1.321,0,1,1,1.321-1.321A1.322,1.322,0,0,1,172.646,407.139Z",
    transform: "translate(-169.656 -402.828)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3059",
    "data-name": "Group 3059",
    transform: "translate(21.754 44.595)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3058",
    "data-name": "Group 3058",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6480",
    "data-name": "Path 6480",
    d: "M330.591,402.828a2.99,2.99,0,1,0,2.99,2.99A2.994,2.994,0,0,0,330.591,402.828Zm0,4.311a1.321,1.321,0,1,1,1.321-1.321A1.322,1.322,0,0,1,330.591,407.139Z",
    transform: "translate(-327.601 -402.828)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3061",
    "data-name": "Group 3061",
    transform: "translate(12.683 28.852)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3060",
    "data-name": "Group 3060",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6481",
    "data-name": "Path 6481",
    d: "M203.794,165.755H191.831a.835.835,0,0,0,0,1.67h11.963a.835.835,0,1,0,0-1.67Z",
    transform: "translate(-190.996 -165.755)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3063",
    "data-name": "Group 3063",
    transform: "translate(13.334 33.187)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3062",
    "data-name": "Group 3062"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6482",
    "data-name": "Path 6482",
    d: "M212.3,231.035H201.637a.835.835,0,1,0,0,1.67H212.3a.835.835,0,0,0,0-1.67Z",
    transform: "translate(-200.802 -231.035)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3065",
    "data-name": "Group 3065",
    transform: "translate(0 19.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3064",
    "data-name": "Group 3064",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6483",
    "data-name": "Path 6483",
    d: "M33.624,25.132a1.663,1.663,0,0,0-1.294-.615h-26L5.8,21.968a1.672,1.672,0,0,0-.97-1.195l-3.664-1.59A.835.835,0,0,0,.5,20.715l3.664,1.59L8.205,41.912a1.676,1.676,0,0,0,1.635,1.333h20a.835.835,0,0,0,0-1.67h-20L9.349,39.19H29.995a1.676,1.676,0,0,0,1.635-1.333l2.335-11.334A1.663,1.663,0,0,0,33.624,25.132ZM29.995,37.521H9.006L6.671,26.187H32.33Z",
    transform: "translate(0 -19.114)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchantProduct);
export default __webpack_public_path__ + "static/media/merchant-product.e8e5c411.svg";
export { ForwardRef as ReactComponent };